<div
  class="wrapper-page"
  [class.no-header]="
    trackingPage?.sidebar?.sidebarField === null && !trackingPage?.logo?.on
  "
  (click)="onClick($event)"
>
  <div class="checking-section" [ngStyle]="backgroundStyles">
    <app-tracking-page-header
      [noSidebar]="
        trackingPage?.sidebar?.sidebarField === null &&
        !trackingPage?.sidebarProductsFeed?.on
      "
      [noSidebarButton]="trackingPage?.sidebar?.sidebarField === null"
      [logo]="logo"
      [selectedId]="selectedVisualBuilderId"
      (selectBlock)="selectBlock.emit($event)"
      (onSearchClick)="onSearchClick.emit()"
      [preventNavigation]="preventNavigation"
      [isVisualBuilder]="visualBuilder"
      [trackingPage]="trackingPage"
      [mode]="mode"
      (toggleSidebar)="toggleSidebarOpened()"
      (changeLanguage)="changeLanguage.emit($event)"
    >
    </app-tracking-page-header>
    <div
      *ngIf="this.numbers.length > 0; else noTrackings"
      class="tracking-page-items relative visual-builder-block with-border-spacing"
      #checkingSection
      [class.third-level]="
        trackingPage?.sidebar?.sidebarField !== null ||
        !!trackingPage?.sidebarProductsFeed?.on
      "
      [class.selected]="selectedVisualBuilderId?.id === 'background'"
    >
      <div
        class="container-fluid container-min"
        #containerBlock
        *ngIf="
          trackingPage?.sidebar?.sidebarField === null &&
            !trackingPage?.sidebarProductsFeed?.on;
          else thirdLevel
        "
      >
        <div class="blocks-wrapper">
          <div class="wrapper-movement-blocks">
            <app-tracking-page-products-feed
              *ngIf="trackingPage?.mainProductsFeed.on"
              [productFeed]="trackingPage?.mainProductsFeed"
              [productItems]="trackingPage?.mainProductsFeed.productItems"
              feedId="mainProductsFeed"
              [mode]="mode"
              [selectedId]="selectedVisualBuilderId"
              (selectBlock)="selectBlock.emit($event)"
              [isVisualBuilder]="visualBuilder"
            ></app-tracking-page-products-feed>
            <ng-container *ngFor="let number of numbers">
              <div
                class="visual-builder-block"
                [class.selected]="
                  selectedVisualBuilderId?.id?.includes('orderCard')
                "
                (click)="selectBlock.emit('orderCard')"
              >
                <div
                  [class.hasOrder]="number.lastUpdated"
                  [ngStyle]="
                    trackingPage?.orderCard
                      | fontFamily
                      | assign : orderCardStyles
                  "
                >
                  <app-tracking-page-order
                    *ngIf="number.lastUpdated"
                    [order]="number"
                    [id]="number.id"
                    (selectBlock)="selectBlock.emit($event)"
                    [selectedId]="selectedVisualBuilderId"
                    [orderItemsFrame]="trackingPage?.orderItemsFrame"
                    [orderLastUpdated]="trackingPage?.orderLastUpdated"
                    [orderLastUpdatedOn]="trackingPage?.orderLastUpdatedOn"
                    [orderNumber]="trackingPage?.orderNumber"
                    [orderNumberOn]="trackingPage?.orderNumberOn"
                    [orderStatus]="trackingPage?.orderStatus"
                    [orderStatusOn]="trackingPage?.orderStatusOn"
                    [notYetShippedItemsTitle]="
                      trackingPage?.notYetShippedItemsTitle
                    "
                  ></app-tracking-page-order>
                  <app-tracking-page-item
                    *ngFor="let shipment of number.trackingNumbers"
                    [reviewEnabled]="reviewEnabled"
                    (showFeedback)="
                      showFeedbackModal({
                        id: shipment.id,
                        data: shipment.review,
                        number: shipment
                      })
                    "
                    [number]="shipment"
                    [checkpoints]="checkpoints[shipment.id]"
                    [detailsButton]="trackingPage?.detailsButton"
                    [card]="trackingPage?.card"
                    [orderItemsFrame]="trackingPage?.orderItemsFrame"
                    (toggleDetails)="toggleCheckpoints($event, number.id)"
                    [open]="
                      showDetails
                        | idIncludes : (shipment.id | concatIds : number.id)
                    "
                    [checkpointsLoading]="
                      showDetailsLoading
                        | idIncludes : (shipment.id | concatIds : number.id)
                    "
                    (selectBlock)="selectBlock.emit($event)"
                    [selectedId]="selectedVisualBuilderId"
                  >
                  </app-tracking-page-item>
                </div>
              </div>
            </ng-container>
            <div
              class="show-more"
              *ngIf="loadMoreTrackingNumbers"
              [ngStyle]="
                trackingPage?.card
                  | fontFamily
                  | assign
                    : {
                        backgroundColor: trackingPage?.card?.backgroundColor,
                        boxShadow: trackingPage?.card?.shadow,
                        borderColor: trackingPage?.card?.borderColor,
                        borderStyle: 'solid',
                        'borderWidth.px': trackingPage?.card?.borderWidth,
                        'borderRadius.px': trackingPage?.card?.borderRadius
                      }
              "
              (click)="triggerLoadMoreTrackingNumbers.emit()"
            >
              Show More (<strong>{{ moreTrackingNumberValues }}</strong
              >)
            </div>
          </div>
        </div>
      </div>
      <ng-template #thirdLevel>
        <div
          class="container"
          [class.show-more-values-visible]="moreValues && !showMoreSideBarItems"
        >
          <div [class.row]="mode === 'desktop' || !mode">
            <div
              [class.col-4]="mode === 'desktop' || !mode"
              class="sidebar-block mb-4"
              style="flex-grow: 1"
              #sidebarBlock
            >
              <app-tracking-page-products-feed
                #sidebarProductsFeed
                *ngIf="trackingPage?.sidebarProductsFeed.on && !isMobile"
                [productFeed]="trackingPage?.sidebarProductsFeed"
                [productItems]="trackingPage?.sidebarProductsFeed.productItems"
                [mode]="mode"
                feedId="sidebarProductsFeed"
                [selectedId]="selectedVisualBuilderId"
                (selectBlock)="selectBlock.emit($event)"
                [isVisualBuilder]="visualBuilder"
              ></app-tracking-page-products-feed>
              <app-tracking-page-sidebar
                *ngIf="
                  trackingPage?.sidebar?.sidebarField !== null &&
                  sideBarItems?.length > 0
                "
                #sidebar
                [sidebar]="trackingPage?.sidebar"
                [sideBarItems]="sideBarItems"
                [sideBarItemsOpened]="sideBarItemsOpened"
                [showMoreSideBarItems]="showMoreSideBarItems"
                [moreValues]="moreValues"
                [selectedItem]="selectedItem"
                [sidebarOpened]="sidebarOpened$ | async"
                (toggleSidebar)="toggleSidebarOpened()"
                (selectTrackingNumber)="selectTrackingNumber.emit($event)"
                (toggleSideBarItemOpen)="toggleSideBarItemOpen.emit($event)"
                (showMore)="showMore.emit()"
                [selectedId]="selectedVisualBuilderId"
                (selectBlock)="selectBlock.emit($event)"
                [loadMoreVisible]="loadMoreVisible"
              >
              </app-tracking-page-sidebar>
            </div>
            <div
              class="blocks-wrapper"
              #blocksWrapper
              [class.col-8]="mode === 'desktop' || !mode"
            >
              <div class="wrapper-movement-blocks pl-0 pr-0">
                <app-tracking-page-products-feed
                  *ngIf="trackingPage?.sidebarProductsFeed.on && isMobile"
                  [productFeed]="trackingPage?.sidebarProductsFeed"
                  [productItems]="
                    trackingPage?.sidebarProductsFeed.productItems
                  "
                  [mode]="mode"
                  feedId="sidebarProductsFeed"
                  [selectedId]="selectedVisualBuilderId"
                  (selectBlock)="selectBlock.emit($event)"
                  [isVisualBuilder]="visualBuilder"
                ></app-tracking-page-products-feed>

                <app-tracking-page-products-feed
                  #mainProductsFeed
                  *ngIf="trackingPage?.mainProductsFeed.on"
                  [productFeed]="trackingPage?.mainProductsFeed"
                  [productItems]="trackingPage?.mainProductsFeed.productItems"
                  feedId="mainProductsFeed"
                  [mode]="mode"
                  [selectedId]="selectedVisualBuilderId"
                  (selectBlock)="selectBlock.emit($event)"
                  [isVisualBuilder]="visualBuilder"
                ></app-tracking-page-products-feed>
                <ng-container *ngFor="let number of numbers">
                  <div
                    class="visual-builder-block"
                    [class.selected]="
                      selectedVisualBuilderId?.id?.includes('orderCard')
                    "
                    (click)="selectBlock.emit('orderCard')"
                  >
                    <div
                      [class.hasOrder]="number.lastUpdated"
                      [ngStyle]="
                        trackingPage?.orderCard
                          | fontFamily
                          | assign : orderCardStyles
                      "
                    >
                      <app-tracking-page-order
                        *ngIf="number.lastUpdated"
                        [id]="number.id"
                        [order]="number"
                        (selectBlock)="selectBlock.emit($event)"
                        [selectedId]="selectedVisualBuilderId"
                        [orderItemsFrame]="trackingPage?.orderItemsFrame"
                        [orderLastUpdated]="trackingPage?.orderLastUpdated"
                        [orderLastUpdatedOn]="trackingPage?.orderLastUpdatedOn"
                        [orderNumber]="trackingPage?.orderNumber"
                        [orderNumberOn]="trackingPage?.orderNumberOn"
                        [orderStatus]="trackingPage?.orderStatus"
                        [orderStatusOn]="trackingPage?.orderStatusOn"
                        [notYetShippedItemsTitle]="
                          trackingPage?.notYetShippedItemsTitle
                        "
                      ></app-tracking-page-order>
                      <app-tracking-page-item
                        [id]="shipment.id"
                        *ngFor="let shipment of number.trackingNumbers"
                        [reviewEnabled]="reviewEnabled"
                        (showFeedback)="
                          showFeedbackModal({
                            id: shipment.id,
                            data: shipment.review,
                            number: shipment
                          })
                        "
                        [number]="shipment"
                        [checkpoints]="checkpoints[shipment.id]"
                        [detailsButton]="trackingPage?.detailsButton"
                        [card]="trackingPage?.card"
                        [orderItemsFrame]="trackingPage?.orderItemsFrame"
                        (toggleDetails)="toggleCheckpoints($event, number.id)"
                        [open]="
                          showDetails
                            | idIncludes : (shipment.id | concatIds : number.id)
                        "
                        [checkpointsLoading]="
                          showDetailsLoading
                            | idIncludes : (shipment.id | concatIds : number.id)
                        "
                        (selectBlock)="selectBlock.emit($event)"
                        [selectedId]="selectedVisualBuilderId"
                      >
                      </app-tracking-page-item>
                    </div>
                  </div>
                </ng-container>
                <div
                  class="show-more tracking-numbers"
                  *ngIf="loadMoreTrackingNumbers"
                  [ngStyle]="
                    trackingPage?.card
                      | fontFamily
                      | assign
                        : {
                            backgroundColor:
                              trackingPage?.card?.backgroundColor,
                            boxShadow: trackingPage?.card?.shadow,
                            borderColor: trackingPage?.card?.borderColor,
                            borderStyle: 'solid',
                            'borderWidth.px': trackingPage?.card?.borderWidth,
                            'borderRadius.px': trackingPage?.card?.borderRadius
                          }
                  "
                  (click)="triggerLoadMoreTrackingNumbers.emit()"
                >
                  Show More (<strong>{{ moreTrackingNumberValues }}</strong
                  >)
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <ng-template #noTrackings>
      <div class="no-trackings">
        <svg
          height="92"
          viewBox="0 0 99 92"
          width="99"
          xmlns="http://www.w3.org/2000/svg"
          class="ng-star-inserted"
        >
          <g fill="none" fill-rule="evenodd" transform="translate(0 1)">
            <ellipse
              cx="49"
              cy="69"
              fill="#ced2dc"
              fill-opacity=".36533"
              opacity=".5"
              rx="49"
              ry="22"
            ></ellipse>
            <path
              d="m44 50v31l39.5-20v-30.5z"
              fill="#fff6f1"
              stroke="#ee7227"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
            <path
              d="m44 81-29-14.5v-30.5l29 14z"
              fill="#fff6f1"
              stroke="#ee7227"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
            <path
              d="m15 36 40-19.5 28.5 14-39.5 19.5z"
              fill="#fff6f1"
              stroke="#ee7227"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
            <path d="m55 44.5v-28l28.5 14z" fill="#f6dfd1"></path>
            <g
              fill="#fff6f1"
              stroke="#ee7227"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            >
              <path d="m44 50 14 2.5 40-20-14.5-2z"></path>
              <path d="m83.5 30.5 8-17-27.5-13.5-9 16.5z"></path>
              <path d="m55 16.5-11-12-39 19.5 10 12z"></path>
              <path d="m55 16.5v28"></path>
              <path d="m44 50-6-12-33-14 10 12z"></path>
            </g>
          </g>
        </svg>
        <p
          [style.font-size.px]="trackingPage?.searchPageTitle?.fontSize || 18"
          [ngStyle]="trackingPage?.searchPageTitle | fontFamily"
          [innerHTML]="'no_trackings' | translate"
        ></p>
      </div>
    </ng-template>
    <app-tracking-page-footer
      [trackingPage]="trackingPage"
      [noSidebar]="trackingPage?.sidebar?.sidebarField === null"
      [mode]="mode"
      [isVisualBuilder]="visualBuilder"
      [selectedId]="selectedVisualBuilderId"
      (selectItem)="selectBlock.emit($event)"
    >
    </app-tracking-page-footer>
  </div>
</div>
